import React from "react";
import ReactDom from "react-dom";
import styled from "styled-components";
import TGBSquareLogo from "../../MemberDashboard/Icons/TGBSquareLogo";
import { T100 } from "./SharedStyles";
import XIcon from "@/components/MemberDashboard/Icons/XIcon";
import { SentientFont } from "./SharedStyles";
import I18n from "../../../translations/i18n";

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: flex-end;
  padding: 16px;
  z-index: 99999999999;
`;

const Modal = styled.div`
  display: flex;
  width: 100%;
  max-width: 560px;
  padding: 24px 16px;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  border-radius: 16px;
  background: #fff;
  position: relative;
  font-family: ${({ theme }) => theme.primaryFont} !important;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  border: none;
  background: none;
  font-size: 20px;
  cursor: pointer;
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

const CobrandedLogo = styled.img`
  height: 48px;
`;


type ModalWrapperProps = {
  children: React.ReactNode;
  handleClose: () => void;
  cobrandingEnabled: boolean;
  hotelLogoURL: string;
};

const ModalWrapper = ({ children, handleClose, cobrandingEnabled, hotelLogoURL }: ModalWrapperProps) => {

  return ReactDom.createPortal(
    <Overlay onClick={handleClose}>
      <CloseButton onClick={handleClose}>
        <XIcon size={24} color={"#FCFCFC"}/>
      </CloseButton>
      <SentientFont />
      <Modal onClick={(e) => e.stopPropagation()}>
        <HeaderContainer>
          {cobrandingEnabled ? 
            <CobrandedLogo src={hotelLogoURL}/>
            :
            <TGBSquareLogo />
          }
          
          {cobrandingEnabled &&
            <T100>{I18n.t(`views.hotel_integration.components.widget.mobile_modal.powered_by`)}</T100>
          }
        </HeaderContainer>
        {children}
      </Modal>
    </Overlay>,
    document.body
  );
};

export default ModalWrapper;
